// router path
export const DASHBOARD = "/dashboard";
export const LEND = "/lend";
export const BORROW = "/borrow";
export const MARKETS = "/markets";
export const HISTORY = "/history";
export const LIQUIDATE = "/liquidate";
export const SWAP = "/swap";
